import type {CommonProps} from '../types';

export default ({color = 'currentColor', size = 16, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 16 16"
    {...rest}
  >
    <g
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M7.991 12.002a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5z"
        strokeWidth="1.000005"
      />
      <path
        d="M7.991.502a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5z"
        strokeWidth="1.000005"
      />
      <path
        d="M7.991 6.252a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5z"
        strokeWidth="1.000005"
      />
    </g>
  </svg>
);
